import { useContext, useState } from "react";
import { classList } from "@utils";
import { NavLink } from "react-router-dom";
import DropDownMenuItem from "./DropDownMenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppContext } from "app/appContext";
import { notificationMarkSeen } from "app/services/notificationService";

const DropDownMenu = (props) => {
  const { closeSecSidenav, menu } = props;
  const { getNotificationSeen, user } = useContext(AppContext);
  const [state, setState] = useState({
    open: false,
  });

  const onItemClick = (e) => {
    e.preventDefault();
    setState({ open: !state.open });
  };
  const markNotificationSeen = (value) => {
    debugger;
    const pathTypeMap = {
      "/admin/flight/cancel-request": "cancel-status",
      "/admin/flight/booking-history": "hold-status",
    };

    const notifyType = pathTypeMap[value.path];

    const result = sessionStorage.getItem("multi-notification");
    if (!result) return null;

    const resObj = JSON.parse(result);
    if (!Array.isArray(resObj)) return null;

    const notif = resObj.find((n) => n.type === notifyType);

    if (!notif.isSeen && notif.type == notifyType) {
      debugger;
      notificationMarkSeen(notifyType);
    }
  };
  const renderLevels = (items) =>
    items.sub.map((item, i) => {
      if (item.sub) {
        return (
          <DropDownMenuItem key={i} item={item}>
            {renderLevels(item.sub)}
          </DropDownMenuItem>
        );
      } else {
        return (
          <li
            key={i}
            className={classList({
              "nav-item": true,
              open: state.open,
            })}
            onClick={() => {
              closeSecSidenav();
              if (items.name?.toLowerCase() === "flight") {
                markNotificationSeen(item);
              }
            }}
          >
            <NavLink
              exact={"true"}
              to={item.path}
              className={({ isActive }) => (isActive ? "selected" : undefined)}
            >
              <FontAwesomeIcon
                icon={item.icon}
                size="1x"
                style={{ marginRight: "5px" }}
              />
              <div
                className="item-name"
                style={{
                  position: "relative",
                }}
              >
                {/* {JSON.stringify(console.log(items))} */}
                {items.name?.toLowerCase() === "flight" && (
                  // getNotificationSeen(item.path) &&
                  <div>
                    {item.path === "/admin/flight/cancel-request" &&
                      !getNotificationSeen(item.path)?.isSeen && (
                        <span
                          style={{
                            width: "6px",
                            height: "6px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            boxShadow: "0 0 8px rgba(0, 0, 0, 0.5)",
                            position: "absolute",
                            top: "8px",
                            right: "-17px",
                          }}
                        ></span>
                      )}

                    {item.path === "/admin/flight/booking-history" &&
                      !getNotificationSeen(item.path)?.isSeen && (
                        <span
                          style={{
                            width: "6px",
                            height: "6px",
                            backgroundColor: "red",
                            borderRadius: "50%",
                            boxShadow: "0 0 8px rgba(0, 0, 0, 0.5)",
                            position: "absolute",
                            top: "8px",
                            right: "-17px",
                          }}
                        ></span>
                      )}
                  </div>
                )}

                {item.name}
              </div>
            </NavLink>
          </li>
        );
      }
    });

  return <ul className="childNav">{renderLevels(menu)}</ul>;
};

export default DropDownMenu;
